// This file is auto generated by data-scripts/_helpers/runtime.ts
import commonWords from './commonWords.json';
import firstnames from './firstnames.json';
import lastnames from './lastnames.json';
import wikipedia from './wikipedia.json';
import translations from './translations';
const dictionary = { commonWords, firstnames, lastnames, wikipedia };
export { dictionary, translations };
//# sourceMappingURL=index.js.map